import React from 'react';
import { DrawStatus } from '@apply/constants';
import { DrawFilterBox, DrawFilterBoxColor } from './DrawFilterBox';
import {
    faClock,
    faEnvelope,
    faHouseCircleExclamation,
    faTruckArrowRight,
    faBank,
    faCheckSquare,
} from '@fortawesome/free-solid-svg-icons';

export interface DrawStatusCounts {
    all: number;
    inProgress: number;
    request: number;
    inspecting: number;
    needToFund: number;
    notFinalized: number;
    finalized: number;
}

export interface DrawStatusFilterParameters extends DrawStatusCounts {
    filterDrawStatus: DrawStatus | undefined;
    set_drawStatus: React.Dispatch<React.SetStateAction<DrawStatus | undefined>>;
}

export const DrawStatusFilter: React.FC<DrawStatusFilterParameters> = ({
    filterDrawStatus,
    set_drawStatus,
    all,
    inProgress,
    request,
    inspecting,
    needToFund,
    notFinalized,
    finalized,
}) => {
    return (
        <div
            className='box-filter'
            style={{ width: 1280 }}
        >
            <DrawFilterBox
                onClick={() => set_drawStatus(undefined)}
                text='All'
                color={DrawFilterBoxColor.White}
                count={all}
                isActive={filterDrawStatus === undefined}
            />
            <DrawFilterBox
                onClick={() => set_drawStatus(DrawStatus.InProgress)}
                text='In Progress'
                color={DrawFilterBoxColor.Gray}
                icon={faClock}
                count={inProgress}
                isActive={filterDrawStatus === DrawStatus.InProgress}
            />
            <DrawFilterBox
                onClick={() => set_drawStatus(DrawStatus.Request)}
                text='Request'
                color={DrawFilterBoxColor.Yellow}
                icon={faEnvelope}
                count={request}
                isActive={filterDrawStatus === DrawStatus.Request}
            />
            <DrawFilterBox
                onClick={() => set_drawStatus(DrawStatus.Inspecting)}
                text='Inspecting'
                color={DrawFilterBoxColor.Blue}
                icon={faTruckArrowRight}
                count={inspecting}
                isActive={filterDrawStatus === DrawStatus.Inspecting}
            />
            <DrawFilterBox
                onClick={() => set_drawStatus(DrawStatus.NeedToFund)}
                text='Need to Fund'
                color={DrawFilterBoxColor.Red}
                icon={faHouseCircleExclamation}
                count={needToFund}
                isActive={filterDrawStatus === DrawStatus.NeedToFund}
            />
            <DrawFilterBox
                onClick={() => set_drawStatus(DrawStatus.NotFinalized)}
                text='Not Finalized'
                color={DrawFilterBoxColor.Orange}
                icon={faCheckSquare}
                count={notFinalized}
                isActive={filterDrawStatus === DrawStatus.NotFinalized}
            />
            <DrawFilterBox
                onClick={() => set_drawStatus(DrawStatus.Finalized)}
                text='Finalized'
                color={DrawFilterBoxColor.Green}
                icon={faBank}
                count={finalized}
                isActive={filterDrawStatus === DrawStatus.Finalized}
            />
        </div>
    );
};
